import { createGlobalStyle } from "styled-components";

export const LotteryModalStyle = createGlobalStyle`
.lottery-modal {
  .ant-modal-title {
    text-align: center;
    color: #edf7fa;
    font-size: 18px;
    font-weight: 600;
  }
  .topup_form_back {
    display: flex;
    justify-content: space-between;
    width: 54%;
    div {
      font-weight: 600;
      font-size: 14px;
      color: #b2b8bb;
    }
  }
  .topup_prize_back {
    justify-content: center;
    width: 100%;
  }
}
`;
